import { useState , useEffect } from 'react';
import api from '../../utils/api';
import ProjectTitle from '../components/ProjectTitle';
import { useParams } from 'react-router-dom';

export default function ProjectDetails(props) {

  const [details, setDetails] = useState({
    'id': 0,
    'created': '',
    'title': '',
    'general_category': '',
    'specific_category': '',
    'mentee_max': '',
    'mentor': '',
    'description': '',
    'weekly_meets':'',
    'timeline': '',
    'checkpoints': '',
    'prerequisites': '',
    'co_mentor_info': '',
    'banner_image': null,
    'banner_image_link':null,
    'code': '',
    'season': 1,
  });
  let { ProjectId, domain } = useParams();
  ProjectId = parseInt(ProjectId);
  const [wishlist, setWishlist] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [domainSettings, setDomainSettings] = useState({ show_mentor_details: true });

  useEffect(() => {
    api.get(`${process.env.REACT_APP_BACKEND_URL}/projects/${ProjectId}/`)
      .then((response) => {
        // Assuming the response contains the image URL
        // console.log(response.data);

        if (response.data.banner_image) {
          response.data.banner_image = `${process.env.REACT_APP_API_URL}${response.data.banner_image}`;
        }
        response.data.description = response.data.description.split('\\r\\n').join('<br>');
        response.data.description = response.data.description.replace(
          /(https?:\/\/[^\s]+)/g,
          '<Link to="$1" class="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">$1</Link>',
        );
        setDetails(response.data);
      })
      .catch((error) => {
        console.error('Error fetching card image:', error);
      });
  }, []);

  // Fetch domain settings
  useEffect(() => {
    if (domain) {
      api.get(`${process.env.REACT_APP_BACKEND_URL}/domains/${domain}/`)
        .then((response) => {
          setDomainSettings(response.data);
        })
        .catch((error) => {
          console.error('Error fetching domain settings:', error);
        });
    }
  }, [domain]);

  const [Added, setAdded] = useState();
  useEffect(() => {
    const endpoint = domain
      ? `${process.env.REACT_APP_BACKEND_URL}/projects/wishlist/?domain=${domain}`
      : `${process.env.REACT_APP_BACKEND_URL}/projects/wishlist/`;
    
    api.get(endpoint)
      .then((response) => {
        setWishlist(response.data);
        setIsLoading(false);
        const isAdded = response.data.some((item) => item.id === ProjectId);
        setAdded(isAdded);
      })
      .catch((error) => {
        console.error('Error fetching card image:', error);
        setIsLoading(false);
      });
  }, [Added, domain, ProjectId]);

  const wishDetails = {
    project_id: details.id,
    title: details.title,
    banner_image: details.banner_image,
    general_category: details.general_category,
  };
        
  const formData = new FormData();
        
  Object.keys(wishDetails).forEach(key => {
    formData.append(key, wishDetails[key]);
  });
        
  const WishlistAdd = (e) => {
    if (!Added) {
      if (domain) {
        formData.append('domain', domain);
      }
      
      api
        .post(`${process.env.REACT_APP_BACKEND_URL}/projects/wishlist/`, formData)
        .then((res) => {
          setAdded(true);
        })
        .catch((err) => console.log(err));
    } 
    else {
      const deleteUrl = domain
        ? `${process.env.REACT_APP_BACKEND_URL}/projects/wishlist/?project_id=${details.id}&domain=${domain}`
        : `${process.env.REACT_APP_BACKEND_URL}/projects/wishlist?project_id=${details.id}`;
      
      api.delete(deleteUrl)
        .then((res) => {
          setAdded(false);
        })
        .catch((err) => console.log(err));
    }
  };
    
  const buttonMessage = Added ? 'Remove From Wishlist' : 'Add To Wishlist';

  return (  
    <>
      {isLoading ? <div className="h-screen flex justify-center items-center">
        <div className="flex gap-2">
          <div className="w-5 h-5 rounded-full animate-pulse bg-blue-600" />
          <div className="w-5 h-5 rounded-full animate-pulse bg-blue-600" />
          <div className="w-5 h-5 rounded-full animate-pulse bg-blue-600" />
        </div>
      </div> : 
        <div className="px-10 py-10 sm:px-2 md:px-10 lg:px-24">
                
          <div className='pb-10 flex items-center justify-center'>
            <div className="relative inline-flex justify-start overflow-hidden transition-all bg-white rounded hover:bg-white group">
              <span className="w-0 h-0 rounded bg-indigo-600 absolute top-0 left-0 ease-out duration-500 transition-all group-hover:w-full group-hover:h-full -z-1" />
              <ProjectTitle text={`Project ID: ${details.id} ${details.title} `}/>
            </div>
          </div>
          <div className="grid grid-cols-1 pb-10 gap-4 lg:grid-cols-3 lg:gap-8">
            {(details.banner_image || details.banner_image_link) && (
              <div className="h-56 rounded-lg">
                <img alt="" src={details.banner_image} className="h-56 w-full object-contain"/>
              </div>
            )}
            <div className={`rounded-lg ${(details.banner_image || details.banner_image_link) ? 'lg:col-span-2' : 'lg:col-span-3'} h-75`}>
                        
              <div className="grid grid-cols-1 gap-1 lg:grid-cols-2 lg:gap-8">
                {domainSettings.show_mentor_details && (
                  <div className="h-12 rounded-lg">
                    <h4 className=" pt-5 text-2xl text-indigo-400 sm:text-3xl">Mentors:</h4>
                    <ul className="pl-8 sm:pl-2 md:pl-8 lg:pl-20">
                      {details.mentor_details && details.mentor_details.length > 0 ? (
                        details.mentor_details.map((mentor, idx) => (
                          <li key={idx} className="mb-2">
                            <p className="font-semibold">{mentor.name} ({mentor.roll_number})</p>
                            <p className="text-sm text-gray-600"> {mentor.phone_number}</p>
                          </li>
                        ))
                      ) : (
                        <p>{details.mentor}</p>
                      )}
                    </ul>
                  </div>
                )}
                {domainSettings.show_mentor_details && (
                  <div className="h-28 rounded-lg">
                    <h4 className=" pt-5 text-2xl text-indigo-400 sm:text-3xl">Co-Mentors:</h4>
                    <ul className="pl-8 sm:pl-2 md:pl-8 lg:pl-20">
                      {details.co_mentor_details && details.co_mentor_details.length > 0 ? (
                        details.co_mentor_details.map((coMentor, idx) => (
                          <li key={idx} className="mb-2">
                            <p className="font-semibold">{coMentor.name} ({coMentor.roll_number})</p>
                            <p className="text-sm text-gray-600"> {coMentor.phone_number}</p>
                          </li>
                        ))
                      ) : (
                        <li>
                          <p dangerouslySetInnerHTML={{ __html: details.co_mentor_info.replace(/\\r\\n/g, '<br>') }} />
                        </li>
                      )}
                    </ul>
                  </div>
                )}
              </div>
              <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-8">
                {domainSettings.show_mentor_details && (
                  <div className="h-10 rounded-lg ">
                    <h4 className=" pt-5 text-2xl text-indigo-400 sm:text-3xl">Mentees:</h4>
                    <ul className="pl-8 sm:pl-2 md:pl-8 lg:pl-20">
                      <li>
                        {/* <p>20+</p> */}
                        <p>{details.mentee_max}</p>
                      </li>
                    </ul>
                  </div>
                )}
                <div className="h-28 rounded-lg">
                  <h4 className=" pt-5 text-2xl text-indigo-400 sm:text-3xl">General Category:</h4>
                  <ul className="pl-8 sm:pl-2 md:pl-8 lg:pl-20">
                    <li>
                      {/* <p>20+</p> */}
                      <p>{details.general_category}</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-8">
                <div className="h-28 rounded-lg">
                  <h4 className=" pt-5 text-2xl text-indigo-400 sm:text-3xl">Specific Category:</h4>
                  <ul className="pl-8 sm:pl-2 md:pl-8 lg:pl-20">
                    <li>
                      <p>{details.specific_category}</p>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <WishlistButton str={str} WishlistAdd={WishlistAdd}/> */}
              {!props.isPreferenceFilled && (
                <button
                  onClick={WishlistAdd}
                  className={`text-white font-bold ${
                    buttonMessage === 'Remove From Wishlist' ? 'bg-red-600 hover:bg-red-700' : 'bg-indigo-600 hover:bg-indigo-700'
                  } text-white font-bold py-2 px-4 rounded inline-flex items-center`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 mr-2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m6.75 7.5 3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0 0 21 18V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v12a2.25 2.25 0 0 0 2.25 2.25Z"
                    />
                  </svg>
                  <p>{buttonMessage}</p>
                </button>
              )}
            </div>
          </div>

          <div className="flow-root">
            <dl className="-my-3 divide-y divide-gray-100 text-sm">
              <div className="grid grid-cols-1 gap-1 py-3 even:bg-gray-50 sm:grid-cols-3 sm:gap-4">
                <dt className="text-2xl text-indigo-600 sm:text-3xl">Description</dt>
                <dd className="text-gray-700 sm:col-span-2"><p dangerouslySetInnerHTML={{ __html: details.description }} /></dd>
              </div>

              <div className="grid grid-cols-1 gap-1 py-3 even:bg-gray-50 sm:grid-cols-3 sm:gap-4">
                <dt className="text-2xl text-indigo-600 sm:text-3xl">Prerequisites</dt>
                <dd className="text-gray-700 sm:col-span-2">{details.prereuisites}</dd>
              </div>

              {domainSettings.show_mentor_details && (
                <div className="grid grid-cols-1 gap-1 py-3 even:bg-gray-50 sm:grid-cols-3 sm:gap-4">
                  <dt className="text-2xl text-indigo-600 sm:text-3xl">Timeline</dt>
                  <dd className="text-gray-700 sm:col-span-2"><p dangerouslySetInnerHTML={{ __html: details.timeline.replace(/\\r\\n/g, '<br>') }} /></dd>
                </div>
              )}

              {domainSettings.show_mentor_details && (
                <div className="grid grid-cols-1 gap-1 py-3 even:bg-gray-50 sm:grid-cols-3 sm:gap-4">
                  <dt className="text-2xl text-indigo-600 sm:text-3xl">Checkpoints</dt>
                  <dd className="text-gray-700 sm:col-span-2"><p dangerouslySetInnerHTML={{ __html: details.checkpoints.replace(/\\r\\n/g, '<br>') }} /></dd>
                </div>
              )}

              {domainSettings.show_mentor_details && (
                <div className="grid grid-cols-1 gap-1 py-3 even:bg-gray-50 sm:grid-cols-3 sm:gap-4">
                  <dt className="text-2xl text-indigo-600 sm:text-3xl">Number of Weekly Meets Approximately</dt>
                  <dd className="text-gray-700 sm:col-span-2"><p dangerouslySetInnerHTML={{ __html: details.weekly_meets.replace(/\\r\\n/g, '<br>') }} /></dd>
                </div>
              )}
            </dl>
          </div>
        </div>}
    </>
  );
}
